<template>
	<div class="counter d-flex justify-space-between align-center">
		<button class="h3" @click="sub"><span class="pl-1">-</span></button>
		<!--    todo вставить инпут из витралюкса-->
		<v-text-field
				v-model="counter"
				dense hide-details flat
				maxlength="2"
				@focus="onFocus"
				@keydown="filterAmountKey"
				@keyup="fixAmount"
		/>
		<button class="h3" @click="add"><span class="pl-1">+</span></button>
	</div>
</template>

<script>
	export default {
		name: "counter",
		props: ["value", "max"], // max - необязательный верхний предел (напр. лимит предзаказа на заказ)
		data: () => {
			return {
				counter: 0,
			}
		},
		watch: {
			value() {
				this.counter = this.value;
			}
		},
		methods: {
			filterAmountKey(e) {
				//console.log(e);
				const a = e.key;

				// ignore arrows, del, backspace
				if (
					e.keyCode === 37 ||
					e.keyCode === 39 ||
					e.keyCode === 8 ||
					e.keyCode === 46 ||
					e.keyCode === 35 ||
					e.keyCode === 36 ||
					e.keyCode === 9 ||
					(e.key === "x" && e.ctrlKey) ||
					(e.key === "c" && e.ctrlKey) ||
					(e.key === "v" && e.ctrlKey)
				)
					return true;
			},
			fixAmount(e) {
				if (
					e &&
					(e.keyCode === 37 ||
						e.keyCode === 39 ||
						e.keyCode === 8 ||
						e.keyCode === 46 ||
						e.keyCode === 35 ||
						e.keyCode === 36)
				)
					return true;

				let s = this.counter + "";
				s = s.replace(/\D+/g, "");
				//console.log("s=" + s);
				//v = v.substr(1);
				s = Number(s);
				if (isNaN(s)) s = 0;
				else if (s < 0) s = 0;

				//this.isFormValid = s > 0;
				if (this.max > 0 && s > this.max) s = Number(this.max);
					this.counter = s;
				this.$emit("input", this.counter);
				this.$emit("change", this.counter);
			},
			onFocus(event) {
				//this.validateDebounced(item, section);
				event.target.select();
			},
			add() {
					if (this.max > 0 && this.counter >= this.max) return;
				this.counter++;
				this.$emit("input", this.counter);
				this.$emit("change", this.counter);
			},
			sub() {
				if (this.counter <= 1) return 1;
				this.counter--;
				this.$emit("input", this.counter);
				this.$emit("change", this.counter);
			},
		},
		created() {
			this.counter = this.value;
		}
	}
</script>

<style lang="scss">
	.counter {
		width: 100%;
		max-width: 90px;
		height: 41px;
		border: 2px solid $black-50;

		/*h5 {
			color: $black;
		}*/

		button {
			flex-shrink: 0;
			width: 28px;
			height: 28px;
			line-height: 28px;
			padding: 0;
			color: $golden;
			outline: none;
			@include transition();

			&:hover {
				color: $black;
			}
		}

		.v-text-field {
			width: 30px;
			margin: 0;

			input {
				padding: 0 !important;
				width: 100%;
				font-size: 20px;
				text-align: center;
			}

			.v-input__slot:before, .v-input__slot:after {
				border: none !important;
			}

			fieldset {
				height: 40px;
				top: 0;
			}

			legend {
				display: none;
			}
		}
	}

</style>